module.exports = __webpack_public_path__ + "static/media/final.549159cd.JPG";